module.exports = __webpack_public_path__ + "img/mile2m-m@1.2ab50739.jpg";